import type {
  LoginRequestDto,
  LoginResponseDto,
  UpdateProfileRequestDto,
} from 'shared/dtos/authentication.dto';
import type { UserDto } from 'shared/dtos/users.dto';

import { createAsyncThunk } from '@reduxjs/toolkit';
import UserService from 'services/user.service';
import { navigation } from 'shared/utils/navigation';

const userService = new UserService();

export const loginThunk = createAsyncThunk<LoginResponseDto, LoginRequestDto>(
  'authentication/login',
  async ({ username, password }, thunkAPI) => {
    try {
      const result = await userService.login({ username, password });

      if (navigation.navigate) {
        navigation.navigate('/');
      }

      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const logoutThunk = createAsyncThunk(
  'authentication/logout',
  async (_, thunkAPI) => {
    try {
      const result = await userService.logout();
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateProfileThunk = createAsyncThunk<
  UserDto,
  UpdateProfileRequestDto
>('authentication/updateProfile', async ({ email, password }, thunkAPI) => {
  try {
    const result = await userService.updateProfile({ email, password });
    thunkAPI.dispatch(loadUserProfileThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadUserProfileThunk = createAsyncThunk<UserDto>(
  'authentication/loadUserProfile',
  async (_, thunkAPI) => {
    try {
      const result = await userService.loadProfile();
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
